(function () {
  if (window.FC_CART_UPSELL_LOADED_V2) return;
  window.FC_CART_UPSELL_LOADED_V2 = true;

  var FREE_SHIPPING_THRESHOLD = 4500;
  var MAX_OFFERS = 3;

  var productCache = {};
  var activeOffers = {};
  var refreshTimer = null;
  var refreshVersion = 0;

  var PRODUCT_SOURCES = [
    {
      handle: '150gr-bravura-brasilera-de-brasil',
      fixedWeight: '150 g',
      groupWeight: '150'
    },
    {
      handle: '150gr-cumbre-dulce-de-colombia',
      fixedWeight: '150 g',
      groupWeight: '150'
    },
    {
      handle: '150gr-eunoia-de-ruanda',
      fixedWeight: '150 g',
      groupWeight: '150'
    },
    {
      handle: '150gr-inner-fire-blend',
      fixedWeight: '150 g',
      groupWeight: '150'
    },
    {
      handle: '150gr-chocombia-de-colombia-descafeinado',
      fixedWeight: '150 g',
      groupWeight: '150'
    },
    {
      handle: '150gr-rufo-de-kenia',
      fixedWeight: '150 g',
      groupWeight: '150'
    },

    { handle: 'bravura-brasilera' },
    { handle: 'cumbre-dulce' },
    { handle: 'eunoia' },
    { handle: 'inner-fire' },
    { handle: 'chocombia-decaf' },
    { handle: 'rufo-de-kenia' },

    {
      handle: 'pack-degustacion-fanatic-coffee',
      fixedWeight: 'Pack · 450 g',
      groupWeight: 'pack'
    }
  ];

  function getRoot() {
    return document.querySelector('[data-fc-cart-upsell]');
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function detectWeight(value) {
    var text = normalize(value);

    if (
      text.indexOf('1000') !== -1 ||
      text.indexOf('1 kg') !== -1 ||
      text.indexOf('1kg') !== -1 ||
      text.indexOf('1 kilo') !== -1
    ) {
      return '1000';
    }

    if (text.indexOf('500') !== -1) return '500';
    if (text.indexOf('300') !== -1) return '300';
    if (text.indexOf('150') !== -1) return '150';

    return null;
  }

  function displayWeight(weight) {
    if (weight === '1000') return '1 kg';
    if (weight === '500') return '500 g';
    if (weight === '300') return '300 g';
    if (weight === '150') return '150 g';
    if (weight === 'pack') return 'Pack · 450 g';

    return '';
  }

  function coffeeFamily(handle) {
    var value = normalize(handle);

    if (value.indexOf('bravura') !== -1) return 'bravura';
    if (value.indexOf('cumbre') !== -1) return 'cumbre';
    if (value.indexOf('eunoia') !== -1) return 'eunoia';
    if (value.indexOf('inner-fire') !== -1) return 'inner-fire';
    if (value.indexOf('chocombia') !== -1) return 'chocombia';
    if (value.indexOf('rufo') !== -1) return 'rufo';
    if (value.indexOf('degust') !== -1) return 'pack';

    return value;
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function cleanProductTitle(title) {
    return String(title || '')
      .replace(/^150\s*gr\s*/i, '')
      .replace(/^150\s*g\s*/i, '')
      .replace(/^150\s*gramos\s*/i, '')
      .trim();
  }

  function cleanVariantTitle(title, group) {
    var cleaned = String(title || '');

    if (group.groupWeight === 'pack') {
      cleaned = cleaned
        .replace(/150\s*gr\s*por\s*caf[eé]/ig, '')
        .replace(/450\s*gr/ig, '');
    } else if (
      group.groupWeight &&
      group.groupWeight !== '150'
    ) {
      var weight = group.groupWeight;

      var patterns = [
        weight + ' gramos',
        weight + ' gr',
        weight + 'g',
        weight + ' g'
      ];

      if (weight === '1000') {
        patterns.push(
          '1 kg',
          '1kg',
          '1 kilo'
        );
      }

      patterns.forEach(function (pattern) {
        cleaned = cleaned.replace(
          new RegExp(pattern, 'ig'),
          ''
        );
      });
    }

    cleaned = cleaned
      .replace(/^\s*[-/·|]\s*/, '')
      .replace(/\s*[-/·|]\s*$/, '')
      .trim();

    if (
      !cleaned ||
      normalize(cleaned) === 'default title'
    ) {
      return 'En grano';
    }

    return cleaned;
  }

  async function fetchCart() {
    var response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error('No se pudo cargar el carrito.');
    }

    return response.json();
  }

  async function fetchProduct(source) {
    if (productCache[source.handle]) {
      return productCache[source.handle];
    }

    try {
      var response = await fetch(
        '/products/' + source.handle + '.js',
        {
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      );

      if (!response.ok) {
        return null;
      }

      var product = await response.json();

      productCache[source.handle] = {
        source: source,
        product: product
      };

      return productCache[source.handle];

    } catch (error) {
      console.warn(
        '[Fanatic Cart Upsell] No se pudo cargar:',
        source.handle
      );

      return null;
    }
  }

  async function loadProducts() {
    var results = await Promise.all(
      PRODUCT_SOURCES.map(function (source) {
        return fetchProduct(source);
      })
    );

    return results.filter(Boolean);
  }

  function buildGroups(productResults) {
    var groups = [];

    productResults.forEach(function (result) {
      var source = result.source;
      var product = result.product;
      var grouped = {};

      product.variants.forEach(function (variant) {
        if (!variant.available) return;

        var weight;

        if (source.groupWeight) {
          weight = source.groupWeight;
        } else {
          weight = detectWeight(variant.title);
        }

        if (!weight) return;

        var key =
          product.handle +
          '|' +
          weight +
          '|' +
          variant.price;

        if (!grouped[key]) {
          grouped[key] = {
            handle: product.handle,
            family: coffeeFamily(product.handle),
            product: product,
            price: variant.price,
            groupWeight: weight,
            displayWeight:
              source.fixedWeight ||
              displayWeight(weight),
            variants: []
          };
        }

        grouped[key].variants.push(variant);
      });

      Object.keys(grouped).forEach(function (key) {
        groups.push(grouped[key]);
      });
    });

    return groups;
  }

  function getCartContext(cart) {
    var families = new Set();
    var exactGroups = new Set();

    cart.items.forEach(function (item) {
      var handle = item.handle || '';

      if (!handle && item.url) {
        var match = item.url.match(/\/products\/([^?]+)/);

        if (match) {
          handle = match[1];
        }
      }

      if (!handle) return;

      families.add(
        coffeeFamily(handle)
      );

      var weight;

      if (handle.indexOf('150gr-') === 0) {
        weight = '150';
      } else if (
        normalize(handle).indexOf('degust') !== -1
      ) {
        weight = 'pack';
      } else {
        weight = detectWeight(
          item.variant_title ||
          item.title
        );
      }

      if (weight) {
        exactGroups.add(
          handle + '|' + weight
        );
      }
    });

    return {
      families: families,
      exactGroups: exactGroups
    };
  }

  function chooseBestGroups(groups, cart, missing) {
    var context = getCartContext(cart);

    var candidates = groups.filter(function (group) {
      var exactKey =
        group.handle +
        '|' +
        group.groupWeight;

      return !context.exactGroups.has(exactKey);
    });

    if (!candidates.length) {
      candidates = groups.slice();
    }

    var qualifying = candidates.filter(function (group) {
      return group.price >= missing;
    });

    if (!qualifying.length) {
      return [];
    }

    qualifying.sort(function (a, b) {
      var overA = a.price - missing;
      var overB = b.price - missing;

      /*
       * 1. El que menos se pasa de 45 €
       */
      if (overA !== overB) {
        return overA - overB;
      }

      /*
       * 2. Si cuestan lo mismo,
       * priorizamos otro café.
       */
      var aAlready =
        context.families.has(a.family) ? 1 : 0;

      var bAlready =
        context.families.has(b.family) ? 1 : 0;

      if (aAlready !== bAlready) {
        return aAlready - bAlready;
      }

      return a.product.title.localeCompare(
        b.product.title
      );
    });

    /*
     * Primero buscamos 3 cafés distintos.
     */
    var selected = [];
    var selectedFamilies = new Set();

    qualifying.forEach(function (group) {
      if (selected.length >= MAX_OFFERS) return;

      if (!selectedFamilies.has(group.family)) {
        selected.push(group);
        selectedFamilies.add(group.family);
      }
    });

    /*
     * Si no llegamos a 3,
     * completamos con las siguientes opciones.
     */
    if (selected.length < MAX_OFFERS) {
      qualifying.forEach(function (group) {
        if (selected.length >= MAX_OFFERS) return;

        if (selected.indexOf(group) === -1) {
          selected.push(group);
        }
      });
    }

    return selected;
  }

  function getVariantImage(group, variant) {
    if (
      variant &&
      variant.featured_image &&
      variant.featured_image.src
    ) {
      return variant.featured_image.src;
    }

    if (group.product.featured_image) {
      return group.product.featured_image;
    }

    if (
      group.product.images &&
      group.product.images.length
    ) {
      return group.product.images[0];
    }

    return '';
  }

  function setProgress(root, cartTotal, threshold) {
    var progressEl = root.querySelector(
      '[data-fc-cart-progress]'
    );

    if (!progressEl) return;

    var percent =
      threshold > 0
        ? Math.min(
            100,
            Math.max(
              0,
              (cartTotal / threshold) * 100
            )
          )
        : 0;

    progressEl.style.width =
      percent + '%';
  }

  function buildOfferCard(group, index, cartTotal) {
    var offerId = 'offer-' + index;

    var firstVariant =
      group.variants[0];

    activeOffers[offerId] = {
      group: group,
      variant: firstVariant
    };

    var title =
      cleanProductTitle(
        group.product.title
      );

    var image =
      getVariantImage(
        group,
        firstVariant
      );

    var finalTotal =
      cartTotal +
      firstVariant.price;

    var optionsHtml =
      group.variants
        .map(function (variant) {
          return (
            '<option value="' +
            escapeHtml(variant.id) +
            '">' +
            escapeHtml(
              cleanVariantTitle(
                variant.title,
                group
              )
            ) +
            '</option>'
          );
        })
        .join('');

    var selectHtml = '';

    if (group.variants.length > 1) {
      selectHtml =
        '<div class="fc-cart-upsell__variant-wrap">' +
          '<label class="fc-cart-upsell__variant-label">' +
            'Elige molienda' +
          '</label>' +
          '<select ' +
            'class="fc-cart-upsell__select" ' +
            'data-fc-cart-offer-select ' +
            'data-offer-id="' +
            offerId +
          '">' +
            optionsHtml +
          '</select>' +
        '</div>';
    }

    var bestBadge =
      index === 0
        ? '<span class="fc-cart-upsell__best-badge">MEJOR OPCIÓN</span>'
        : '';

    return (
      '<article ' +
        'class="fc-cart-upsell__card' +
        (index === 0
          ? ' fc-cart-upsell__card--best'
          : '') +
        '" ' +
        'data-fc-cart-offer-card="' +
        offerId +
      '">' +

        bestBadge +

        '<div class="fc-cart-upsell__card-main">' +

          '<div class="fc-cart-upsell__image-wrap">' +
            '<img ' +
              'class="fc-cart-upsell__image" ' +
              'src="' +
              escapeHtml(image) +
              '" ' +
              'alt="' +
              escapeHtml(title) +
            '">' +
          '</div>' +

          '<div class="fc-cart-upsell__card-info">' +

            '<p class="fc-cart-upsell__product-title">' +
              escapeHtml(title) +
            '</p>' +

            '<div class="fc-cart-upsell__meta">' +

              '<span class="fc-cart-upsell__weight">' +
                escapeHtml(group.displayWeight) +
              '</span>' +

              '<span ' +
                'class="fc-cart-upsell__price" ' +
                'data-fc-cart-card-price="' +
                offerId +
              '">' +
                escapeHtml(
                  formatMoney(firstVariant.price)
                ) +
              '</span>' +

            '</div>' +

            '<p ' +
              'class="fc-cart-upsell__final-total" ' +
              'data-fc-cart-final-total="' +
              offerId +
            '">' +
              'Tu pedido: ' +
              escapeHtml(
                formatMoney(finalTotal)
              ) +
            '</p>' +

          '</div>' +

        '</div>' +

        selectHtml +

        '<button ' +
          'type="button" ' +
          'class="fc-cart-upsell__button" ' +
          'data-fc-cart-offer-add ' +
          'data-offer-id="' +
          offerId +
        '">' +
          '+ Añadir' +
        '</button>' +

        '<p ' +
          'class="fc-cart-upsell__message" ' +
          'data-fc-cart-offer-message="' +
          offerId +
          '" hidden' +
        '></p>' +

      '</article>'
    );
  }

  function renderOffers(root, groups, cartTotal) {
    activeOffers = {};

    var offerSection =
      root.querySelector(
        '[data-fc-cart-offer]'
      );

    var list =
      root.querySelector(
        '[data-fc-cart-offers-list]'
      );

    var success =
      root.querySelector(
        '[data-fc-cart-success]'
      );

    var fallback =
      root.querySelector(
        '[data-fc-cart-fallback]'
      );

    var swipeHint =
      root.querySelector(
        '[data-fc-cart-swipe-hint]'
      );

    offerSection.hidden = false;
    success.hidden = true;
    fallback.hidden = true;

    list.innerHTML =
      groups
        .map(function (group, index) {
          return buildOfferCard(
            group,
            index,
            cartTotal
          );
        })
        .join('');

    if (swipeHint) {
      swipeHint.hidden =
        groups.length <= 1;
    }
  }

  function renderFreeShipping(root) {
    activeOffers = {};

    root.querySelector(
      '[data-fc-cart-offer]'
    ).hidden = true;

    root.querySelector(
      '[data-fc-cart-fallback]'
    ).hidden = true;

    root.querySelector(
      '[data-fc-cart-success]'
    ).hidden = false;

    root.querySelector(
      '[data-fc-cart-status]'
    ).textContent =
      '¡Envío gratis conseguido!';
  }

  function renderFallback(root, missing) {
    activeOffers = {};

    root.querySelector(
      '[data-fc-cart-offer]'
    ).hidden = true;

    root.querySelector(
      '[data-fc-cart-success]'
    ).hidden = true;

    root.querySelector(
      '[data-fc-cart-fallback]'
    ).hidden = false;

    root.querySelector(
      '[data-fc-cart-status]'
    ).textContent =
      'Te faltan ' +
      formatMoney(missing) +
      ' para el envío gratis';
  }

  async function refreshCartUpsell() {
    var version = ++refreshVersion;

    var root = getRoot();

    if (!root) {
      activeOffers = {};
      return;
    }

    try {
      var cart =
        await fetchCart();

      if (version !== refreshVersion) {
        return;
      }

      if (!cart || cart.item_count === 0) {
        root.hidden = true;
        activeOffers = {};
        return;
      }

      root.hidden = false;

      var threshold =
        parseInt(
          root.dataset.freeShippingThreshold ||
          FREE_SHIPPING_THRESHOLD,
          10
        ) ||
        FREE_SHIPPING_THRESHOLD;

      var total =
        Number(cart.total_price || 0);

      setProgress(
        root,
        total,
        threshold
      );

      if (total >= threshold) {
        renderFreeShipping(root);
        return;
      }

      var missing =
        threshold - total;

      root.querySelector(
        '[data-fc-cart-status]'
      ).textContent =
        'Te faltan ' +
        formatMoney(missing) +
        ' para el envío gratis';

      var products =
        await loadProducts();

      if (version !== refreshVersion) {
        return;
      }

      root = getRoot();

      if (!root) return;

      var groups =
        buildGroups(products);

      var bestGroups =
        chooseBestGroups(
          groups,
          cart,
          missing
        );

      if (!bestGroups.length) {
        renderFallback(
          root,
          missing
        );

        return;
      }

      renderOffers(
        root,
        bestGroups,
        total
      );

    } catch (error) {
      console.error(
        '[Fanatic Cart Upsell]',
        error
      );
    }
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);

    refreshTimer =
      setTimeout(
        refreshCartUpsell,
        typeof delay === 'number'
          ? delay
          : 150
      );
  }

  document.addEventListener(
    'change',
    function (event) {
      var select =
        event.target.closest(
          '[data-fc-cart-offer-select]'
        );

      if (!select) return;

      var offerId =
        select.dataset.offerId;

      var offer =
        activeOffers[offerId];

      if (!offer) return;

      var variantId =
        String(select.value);

      var variant =
        offer.group.variants.find(
          function (item) {
            return String(item.id) ===
              variantId;
          }
        );

      if (!variant) return;

      offer.variant = variant;

      var root = getRoot();

      if (!root) return;

      var priceEl =
        root.querySelector(
          '[data-fc-cart-card-price="' +
          offerId +
          '"]'
        );

      if (priceEl) {
        priceEl.textContent =
          formatMoney(variant.price);
      }

      fetchCart().then(function (cart) {
        var totalEl =
          root.querySelector(
            '[data-fc-cart-final-total="' +
            offerId +
            '"]'
          );

        if (totalEl) {
          totalEl.textContent =
            'Tu pedido: ' +
            formatMoney(
              cart.total_price +
              variant.price
            );
        }
      });
    }
  );

  document.addEventListener(
    'click',
    async function (event) {
      var button =
        event.target.closest(
          '[data-fc-cart-offer-add]'
        );

      if (!button) return;

      event.preventDefault();

      var offerId =
        button.dataset.offerId;

      var offer =
        activeOffers[offerId];

      if (!offer || !offer.variant) {
        return;
      }

      var variant =
        offer.variant;

      var root =
        getRoot();

      var message =
        root
          ? root.querySelector(
              '[data-fc-cart-offer-message="' +
              offerId +
              '"]'
            )
          : null;

      if (message) {
        message.hidden = true;
        message.textContent = '';
        message.classList.remove(
          'is-error',
          'is-success'
        );
      }

      button.disabled = true;
      button.textContent =
        'Añadiendo...';

      try {
        var response =
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json',
              'X-Requested-With':
                'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variant.id,
              quantity: 1
            })
          });

        if (!response.ok) {
          throw new Error(
            'No se pudo añadir el producto.'
          );
        }

        await response.json();

        var cart =
          await fetchCart();

        button.textContent =
          'Añadido ✓';

        document.dispatchEvent(
          new CustomEvent(
            'cart:update',
            {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId:
                  'fc-cart-upsell',
                data: {
                  source:
                    'cart-upsell',
                  itemCount:
                    cart.item_count,
                  variantId:
                    String(variant.id)
                }
              }
            }
          )
        );

        scheduleRefresh(100);

        setTimeout(function () {
          scheduleRefresh(500);
        }, 500);

        setTimeout(function () {
          scheduleRefresh(1000);
        }, 1000);

      } catch (error) {
        console.error(
          '[Fanatic Cart Upsell]',
          error
        );

        var currentRoot =
          getRoot();

        var currentMessage =
          currentRoot
            ? currentRoot.querySelector(
                '[data-fc-cart-offer-message="' +
                offerId +
                '"]'
              )
            : null;

        if (currentMessage) {
          currentMessage.hidden = false;

          currentMessage.textContent =
            'No se ha podido añadir. Inténtalo de nuevo.';

          currentMessage.classList.add(
            'is-error'
          );
        }

        button.disabled = false;
        button.textContent =
          '+ Añadir';
      }
    }
  );

  document.addEventListener(
    'cart:update',
    function () {
      scheduleRefresh(250);

      setTimeout(function () {
        scheduleRefresh(750);
      }, 750);
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      scheduleRefresh(100);
    }
  );

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scheduleRefresh(100);
      }
    );
  } else {
    scheduleRefresh(100);
  }
})();